export const recipesData = {
  // ================= ภาคเหนือ =================
  'recipe_khao_soi': {
    id: 'recipe_khao_soi', name: 'ข้าวซอยไก่', basePrice: 60, primaryAction: 'action_boil',
    knowledge: 'ข้าวซอยมีรากฐานมาจากชาวจีนฮ่อที่อพยพมาทางตอนเหนือ เดิมเรียกว่า "ก๋วยเตี๋ยวฮ่อ" ก่อนปรับสูตรใส่กะทิให้ถูกปากคนท้องถิ่น',
    steps: ['สมุนไพรแกง + โขลก 🥣 = พริกแกง', 'เส้นต่างๆ + พริกแกง + ไก่สด + ต้ม 🍲 = ข้าวซอยไก่']
  },
  'recipe_nam_prik_ong': {
    id: 'recipe_nam_prik_ong', name: 'น้ำพริกอ่อง', basePrice: 50, primaryAction: 'action_pound',
    knowledge: 'คำว่า "อ่อง" หมายถึงการเคี่ยวให้งวด มะเขือเทศที่ใช้แต่เดิมคือมะเขือส้มพื้นบ้าน ทำให้มีรสเปรี้ยวอมหวานเป็นเอกลักษณ์',
    steps: ['หมูชิ้น + สับ 🔪 = หมูสับ', 'หมูสับ + มะเขือเทศ + โขลก 🥣 = น้ำพริกอ่อง']
  },
  'recipe_kang_hung_lay': {
    id: 'recipe_kang_hung_lay', name: 'แกงฮังเล', basePrice: 70, primaryAction: 'action_boil',
    knowledge: 'ได้รับอิทธิพลจากพม่า คำว่า "ฮิน" แปลว่าแกง "เล" แปลว่าเนื้อสัตว์ เป็นแกงที่ไม่มีกะทิ นิยมทำในงานบุญใหญ่',
    steps: ['สมุนไพรแกง + โขลก 🥣 = พริกแกง', 'หมูชิ้น + พริกแกง + ต้ม 🍲 = แกงฮังเล']
  },
  'recipe_nam_ngiao': {
    id: 'recipe_nam_ngiao', name: 'ขนมจีนน้ำเงี้ยว', basePrice: 55, primaryAction: 'action_boil',
    knowledge: 'ใช้ "ดอกงิ้ว" เป็นส่วนประกอบสำคัญ ซึ่งเป็นพืชป่าที่ชาวไทใหญ่นิยมนำมาตากแห้งเพื่อถนอมอาหาร',
    steps: ['หมูชิ้น + สับ 🔪 = หมูสับ', 'เส้นต่างๆ + หมูสับ + ต้ม 🍲 = ขนมจีนน้ำเงี้ยว']
  },
  'recipe_sai_ua': {
    id: 'recipe_sai_ua', name: 'ไส้อั่ว', basePrice: 65, primaryAction: 'action_grill',
    knowledge: 'อั่ว แปลว่า แทรก หรือ ยัดไส้ เป็นภูมิปัญญาการถนอมอาหารของชาวล้านนาโดยใช้สมุนไพรกลบกลิ่นคาวและยืดอายุเนื้อหมู',
    steps: ['หมูชิ้น + สับ 🔪 = หมูสับ', 'สมุนไพรแกง + โขลก 🥣 = พริกแกง', 'หมูสับ + พริกแกง + ย่าง ♨️ = ไส้อั่ว']
  },

  // ================= ภาคอีสาน =================
  'recipe_som_tum': {
    id: 'recipe_som_tum', name: 'ส้มตำไทย', basePrice: 50, primaryAction: 'action_pound',
    knowledge: 'มะละกอถูกนำเข้ามาจากทวีปอเมริกาใต้ในสมัยอยุธยาตอนกลาง ส้มตำเริ่มเป็นที่นิยมแพร่หลายในยุครัตนโกสินทร์',
    steps: ['พริกสด + กระเทียม + โขลก 🥣 = พริกกระเทียมโขลก', 'มะละกอ + สับ 🔪 = เส้นมะละกอ', 'เส้นมะละกอ + พริกกระเทียมโขลก + โขลก 🥣 = ส้มตำไทย']
  },
  'recipe_larb_moo': {
    id: 'recipe_larb_moo', name: 'ลาบหมู', basePrice: 60, primaryAction: 'action_mix',
    knowledge: 'หัวใจของลาบอีสานคือ "ข้าวคั่ว" ที่ช่วยดูดซับน้ำยำและเพิ่มความหอม แตกต่างจากลาบคั่วทางเหนือที่เน้นเครื่องเทศพริกดำ',
    steps: ['หมูชิ้น + สับ 🔪 = หมูสับ', 'พริกสด + กระเทียม + โขลก 🥣 = พริกกระเทียมโขลก', 'หมูสับ + พริกกระเทียมโขลก + คลุก 🥗 = ลาบหมู']
  },
  'recipe_tom_zap': {
    id: 'recipe_tom_zap', name: 'ต้มแซ่บกระดูกอ่อน', basePrice: 75, primaryAction: 'action_boil',
    knowledge: 'ต้มแซ่บพัฒนามาจาก "ต้มเครื่องใน" หรือ "ต้มขม" โดยปรับให้รสชาติจัดจ้าน เปรี้ยวเผ็ด ทานง่ายขึ้นสำหรับคนทั่วไป',
    steps: ['พริกสด + กระเทียม + โขลก 🥣 = พริกกระเทียมโขลก', 'หมูชิ้น + พริกกระเทียมโขลก + ต้ม 🍲 = ต้มแซ่บกระดูกอ่อน']
  },
  'recipe_kor_moo_yang': {
    id: 'recipe_kor_moo_yang', name: 'คอหมูย่าง', basePrice: 80, primaryAction: 'action_grill',
    knowledge: 'ใช้เนื้อส่วน "สันคอ" ที่มีไขมันแทรก เวลาย่างไขมันจะละลายหยดลงถ่าน เกิดเป็นควันที่รมกลิ่นเนื้อให้หอมเป็นเอกลักษณ์',
    steps: ['หมูชิ้น + ย่าง ♨️ = หมูย่าง', 'หมูย่าง + สับ 🔪 = คอหมูย่าง']
  },
  'recipe_nam_tok_moo': {
    id: 'recipe_nam_tok_moo', name: 'น้ำตกหมู', basePrice: 70, primaryAction: 'action_mix',
    knowledge: 'ชื่อ "น้ำตก" มาจากลักษณะของน้ำมันและน้ำหวานจากเนื้อหมูที่หยดลงบนเตาถ่านเสียงดังซ่าๆ เวลาย่างแบบกึ่งสุกกึ่งดิบ',
    steps: ['หมูชิ้น + ย่าง ♨️ = หมูย่าง', 'พริกสด + กระเทียม + โขลก 🥣 = พริกกระเทียมโขลก', 'หมูย่าง + พริกกระเทียมโขลก + คลุก 🥗 = น้ำตกหมู']
  },

  // ================= ภาคกลาง =================
  'recipe_tom_yum_goong': {
    id: 'recipe_tom_yum_goong', name: 'ต้มยำกุ้ง', basePrice: 90, primaryAction: 'action_boil',
    knowledge: 'ต้มยำแต่โบราณเป็นน้ำใส การใส่นมสดหรือน้ำพริกเผาให้เป็น "น้ำข้น" เพิ่งเริ่มได้รับความนิยมในสมัยรัชกาลที่ 6',
    steps: ['กุ้งสด + สมุนไพรแกง + ต้ม 🍲 = ต้มยำกุ้ง']
  },
  'recipe_pad_thai': {
    id: 'recipe_pad_thai', name: 'ผัดไทยกุ้งสด', basePrice: 75, primaryAction: 'action_stir_fry',
    knowledge: 'ถือกำเนิดในยุคจอมพล ป. พิบูลสงคราม รณรงค์ให้คนไทยกินก๋วยเตี๋ยวแต่ใช้เส้นจันท์และเครื่องปรุงไทยเพื่อชาตินิยม',
    steps: ['เส้นต่างๆ + กุ้งสด + ผัด 🍳 = ผัดไทยกุ้งสด']
  },
  'recipe_green_curry': {
    id: 'recipe_green_curry', name: 'แกงเขียวหวานไก่', basePrice: 65, primaryAction: 'action_boil',
    knowledge: 'สีเขียวได้มาจากพริกขี้หนูสดและใบพริกตำรวมกัน คำว่า "หวาน" หมายถึงสีเขียวที่ดูนวลละมุน ไม่ได้แปลว่ารสชาติหวานนำ',
    steps: ['สมุนไพรแกง + โขลก 🥣 = พริกแกง', 'ไก่สด + พริกแกง + ต้ม 🍲 = แกงเขียวหวานไก่']
  },
  'recipe_pad_krapow': {
    id: 'recipe_pad_krapow', name: 'ผัดกะเพราหมูสับ', basePrice: 55, primaryAction: 'action_stir_fry',
    knowledge: 'เพิ่งฮิตในไทยราว 70 กว่าปีก่อน ดัดแปลงมาจากการผัดเนื้อสัตว์ของชาวจีน โดยใส่ใบกะเพราของไทยเพื่อดับกลิ่นคาว',
    steps: ['หมูชิ้น + สับ 🔪 = หมูสับ', 'พริกสด + กระเทียม + โขลก 🥣 = พริกกระเทียมโขลก', 'หมูสับ + พริกกระเทียมโขลก + ผัด 🍳 = ผัดกะเพราหมูสับ']
  },
  'recipe_kai_jeaw': {
    id: 'recipe_kai_jeaw', name: 'ไข่เจียวหมูสับ', basePrice: 40, primaryAction: 'action_fry',
    knowledge: 'เมนูคู่ครัวไทยที่รับอิทธิพลการ "เจียว" (ทอดในน้ำมันท่วม) มาจากชาวจีน เป็น Comfort Food ที่คนไทยขาดไม่ได้',
    steps: ['ไข่ไก่ + คลุก 🥗 = ไข่เจียวดิบ', 'หมูชิ้น + สับ 🔪 = หมูสับ', 'ไข่เจียวดิบ + หมูสับ + ทอด 🥘 = ไข่เจียวหมูสับ']
  },

  // ================= ภาคใต้ =================
  'recipe_kua_kling': {
    id: 'recipe_kua_kling', name: 'คั่วกลิ้งหมู', basePrice: 70, primaryAction: 'action_stir_fry',
    knowledge: 'การ "คั่ว" คือการผัดเนื้อสัตว์กับพริกแกงในกระทะจนน้ำแห้งงวดและเนื้อกลิ้งไปมาได้ ช่วยยืดอายุอาหารในพื้นที่อากาศชื้น',
    steps: ['หมูชิ้น + สับ 🔪 = หมูสับ', 'สมุนไพรแกง + โขลก 🥣 = พริกแกง', 'หมูสับ + พริกแกง + ผัด 🍳 = คั่วกลิ้งหมู']
  },
  'recipe_kang_som': {
    id: 'recipe_kang_som', name: 'แกงส้มใต้ (แกงเหลือง)', basePrice: 80, primaryAction: 'action_boil',
    knowledge: 'คนใต้เรียกแกงส้ม แต่คนกรุงเทพฯ เรียกแกงเหลืองเพราะสีของขมิ้นที่เป็นสมุนไพรหลัก ช่วยดับคาวปลาทะเลได้ดีเยี่ยม',
    steps: ['สมุนไพรแกง + โขลก 🥣 = พริกแกง', 'กุ้งสด + พริกแกง + ต้ม 🍲 = แกงส้มใต้']
  },
  'recipe_pad_sato': {
    id: 'recipe_pad_sato', name: 'ผัดสะตอกุ้งสด', basePrice: 85, primaryAction: 'action_stir_fry',
    knowledge: 'สะตอเป็นไม้ยืนต้นตระกูลถั่วพื้นเมืองภาคใต้ มีกลิ่นฉุนเฉพาะตัว นิยมนำมาผัดกับกะปิเพื่อชูรสชาติ',
    steps: ['กุ้งสด + สะตอ + ผัด 🍳 = ผัดสะตอกุ้งสด']
  },
  'recipe_gai_tom_kamin': {
    id: 'recipe_gai_tom_kamin', name: 'ไก่ต้มขมิ้น', basePrice: 65, primaryAction: 'action_boil',
    knowledge: 'ขมิ้นนอกจากจะให้สีเหลืองสวยงามแล้ว ยังมีสรรพคุณทางยาช่วยย่อยอาหาร แก้ท้องอืด เหมาะกับมื้ออาหารรสจัดของภาคใต้',
    steps: ['ไก่สด + สมุนไพรแกง + ต้ม 🍲 = ไก่ต้มขมิ้น']
  },
  'recipe_moo_hong': {
    id: 'recipe_moo_hong', name: 'หมูฮ้อง', basePrice: 85, primaryAction: 'action_boil',
    knowledge: 'อาหารพื้นถิ่นชาวเพอรานากัน (ภูเก็ต) คล้ายหมูพะโล้แต่ไม่ใส่ผงพะโล้ เน้นซีอิ๊วขาว ดำ และกระเทียมพริกไทย',
    steps: ['หมูชิ้น + กระเทียม + ต้ม 🍲 = หมูฮ้อง']
  }
};